module.exports = "<app-navbar></app-navbar>\r\n\r\n<div class=\"container main-container\">\r\n\r\n  <router-outlet></router-outlet>\r\n\r\n</div>\r\n\r\n<app-footer></app-footer>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1